import { useState, useEffect } from 'react';

const BASE_URL = 'https://www.xn--2w2b1dm8gn5nwya81ag35e.com';

export default function PopupBanner() {
  const [isOpen, setIsOpen] = useState(false);
  const [dontShow, setDontShow] = useState(false);

  useEffect(() => {
    const today = new Date().toDateString();
    const savedDate = localStorage.getItem('popup-hide-date');
    if (savedDate !== today) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    if (dontShow) {
      localStorage.setItem('popup-hide-date', new Date().toDateString());
    }
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={handleClose} />
      <div className="relative z-10 w-full max-w-lg">
        {/* Popup Image */}
        <img
          src={`${BASE_URL}/assets/images/popup/popup_260604_03.png`}
          alt="놓칠 수 없는 6가지 이유"
          className="w-full h-auto rounded-xl shadow-2xl"
        />

        {/* Footer Controls */}
        <div className="flex items-center justify-between mt-3 px-1">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={dontShow}
              onChange={(e) => setDontShow(e.target.checked)}
              className="w-4 h-4 rounded border-background-300 bg-background-200 text-primary-500 focus:ring-primary-500"
            />
            <span className="text-xs text-foreground-300">오늘 하루 보지않기</span>
          </label>
          <button
            onClick={handleClose}
            className="text-sm font-medium text-foreground-300 hover:text-foreground-50 transition-colors"
          >
            팝업닫기 <span className="text-lg leading-none">&times;</span>
          </button>
        </div>
      </div>
    </div>
  );
}